// Helpers de style inline partagés (tableaux, cartes, champs).
import React from "react";
import { FONTS, NW } from "./tokens";

export const thS = (e?: React.CSSProperties): React.CSSProperties => ({
  border: "1px solid rgba(255,255,255,0.15)",
  padding: "10px 14px",
  whiteSpace: "nowrap",
  textAlign: "center",
  fontWeight: 700,
  letterSpacing: 0.3,
  ...e,
});

export const tdS = (e?: React.CSSProperties): React.CSSProperties => ({
  border: `1px solid ${NW.gray200}`,
  padding: "8px 14px",
  whiteSpace: "nowrap",
  fontSize: 12,
  ...e,
});

export const card = (extra?: React.CSSProperties): React.CSSProperties => ({
  background: NW.white,
  borderRadius: 14,
  border: `1.5px solid ${NW.gray200}`,
  boxShadow: "0 2px 16px rgba(29,91,168,0.07)",
  ...extra,
});

export const inputStyle: React.CSSProperties = {
  border: `1.5px solid ${NW.gray200}`,
  borderRadius: 8,
  padding: "5px 10px",
  fontSize: 12,
  fontFamily: FONTS.body,
  color: NW.gray800,
  outline: "none",
  background: NW.white,
  transition: "border-color 0.15s",
};

export const dateInputStyle: React.CSSProperties = {
  border: `1.5px solid ${NW.gray200}`,
  borderRadius: 8,
  padding: "5px 10px",
  fontSize: 12,
  fontFamily: FONTS.body,
  color: NW.gray800,
  outline: "none",
  background: NW.white,
  transition: "border-color 0.15s",
  width: 110,
  letterSpacing: 0.5,
};
